import React from 'react'

import classNames from 'classnames'

import { CommonCloseIcon } from '@local/assets/icons'

import ModalContainer from '@web/components/Modal/ModalContainer'
import { ModalComponent } from '@web/components/Modal/types'

import Clickable from '../Clickable'
import Loading from '../Loading'
import styles from './Alert.module.scss'

export const MODAL_LABELS = {
  confirm: '네',
  cancel: '아니요',
}

interface Props {
  confirmDisabled?: boolean
  showCloseButton?: boolean
  isWarningConfirm?: boolean
}

const Alert: ModalComponent<Props> = ({
  cancelModal,
  confirmModal,
  showModal,
  title = null,
  message = '',
  subMessage = '',
  hasLoading = false,
  hasUnderline = false,
  hasSubMessageScroll = false,
  label = {},
  clickCodes = {},
  children,
  className,
  confirmDisabled = false,
  showCloseButton = false,
  isWarningConfirm = false,
}) => {
  const { cancel: labelCancel, confirm: labelConfirm } = label

  return (
    <ModalContainer
      showModal={showModal}
      className={classNames(styles.modal_alert, className, {
        [styles.type_underline]: hasUnderline,
        [styles.type_scroll]: hasSubMessageScroll,
      })}
    >
      {hasLoading && <Loading height={68} />}
      <div className={styles.content_area}>
        {hasLoading && <p className={styles.txt_area}>등록 중입니다.</p>}
        {title && <div className={styles.tit_area}>{title}</div>}
        {message && <div className={styles.txt_area}>{message}</div>}
        {subMessage && <div className={styles.sub_txt_area}>{subMessage}</div>}
        {children}
      </div>
      {(labelConfirm || labelCancel) && (
        <div className={styles.btn_area}>
          {labelCancel && (
            <Clickable onClick={cancelModal} className={styles.btn} nClickCode={clickCodes?.cancel}>
              {labelCancel}
            </Clickable>
          )}
          {labelConfirm && (
            <Clickable
              onClick={confirmModal}
              className={classNames(styles.btn, styles.type_confirm, { [styles.type_warning]: isWarningConfirm })}
              nClickCode={clickCodes?.confirm}
              disabled={confirmDisabled}
            >
              {labelConfirm}
            </Clickable>
          )}
        </div>
      )}
      {showCloseButton && (
        <Clickable className={styles.btn_close} onClick={cancelModal}>
          <CommonCloseIcon className={styles.icon} aria-hidden="true" />
          <span className="place_blind">레이어 닫기</span>
        </Clickable>
      )}
    </ModalContainer>
  )
}

export default Alert
